export default {
  subtitle:
    'Nous envoyons (POST) les événements sélectionnés à vos points de terminaison, signés avec le secret du point de terminaison.',
  regenerate_confirm: 'Générer un nouveau secret de signature ? Le secret actuel cessera de fonctionner immédiatement.',
  delete_confirm: "Supprimer ce point de terminaison ? Il ne recevra plus d'événements.",
  consecutive_failures: '{{count}} échecs consécutifs',
  columns: {
    url: 'Point de terminaison',
    events: 'Événements',
    status: 'Statut',
    secret: 'Secret',
  },
  statuses: {
    active: 'Actif',
    disabled: 'Désactivé',
    auto_disabled: 'Désactivé automatiquement',
  },
  buttons: {
    create: 'Ajouter un point de terminaison',
    edit: 'Modifier',
    regenerate_secret: 'Nouveau secret',
    delete: 'Supprimer',
  },
  toasts: {
    load_error: 'Impossible de charger les points de terminaison webhook.',
    error: "Une erreur s'est produite. Veuillez réessayer.",
    deleted: 'Point de terminaison supprimé.',
  },
};
